import { memo } from 'react';
import { useMount } from 'react-use-v13';
import _ from 'lodash';

function ConsoleLinkWithRedirect({
  relativeHref,
  label,
  className,
}: {
  relativeHref: string;
  label?: string;
  className?: string;
}) {
  useMount(() => {
    if (typeof window === 'undefined') return;
    const urlParams = new URLSearchParams(window.location.search);
    const consoleParam = urlParams.get('redirectToConsole');

    // consoleParam should be empty string or the base URL (it could be canary or localhost)
    if (!_.isNil(consoleParam)) {
      if (!_.isEmpty(consoleParam)) {
        try {
          window.location.href = new URL(relativeHref, consoleParam).toString();
          return;
        } catch (__) {
          // bad base URL, fallback to below
        }
      }
      window.location.href = new URL(relativeHref, 'https://console.scale.com').toString();
    }
  });
  const href = new URL(relativeHref, 'https://console.scale.com').toString();

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={className}>
      {label || 'GenAI Console'}
    </a>
  );
}

export default memo(ConsoleLinkWithRedirect);
